module.exports = "/_next/static/images/GeneralL-7a6e14a6576ef71c15a23b50166f4ef2.svg";